const calculateDecimalFromDelta = async (date1: string, date2: string) : Promise<number> => { //expect two hours in xx:xx format for example 01:30 and 02:30 should return 1
    const [hours1, minutes1] = date1.split(':');
    const [hours2, minutes2] = date2.split(':');
    return (parseFloat(hours2) + parseFloat(minutes2) / 60) - (parseFloat(hours1) + parseFloat(minutes1) / 60);
}

const convertDecimalToHour =  (decimal: number) => {
    const hours = Math.floor(decimal);
    const minutes = (decimal - hours) * 60;
    return `${hours.toString().padStart(2, '0')}:${minutes.toString().padStart(2, '0')}`;
}

const convertHourToDecimal = async (hour: string) : Promise<number> => {
    const [hours, minutes] = hour.split(':');
    return parseFloat(hours) + parseFloat(minutes) / 60;
}

const addHourToHour = (hour1: string, hour2: string) : string => { //add hour2 to hour1
    const [hours1, minutes1] = hour1.split(':');
    const [hours2, minutes2] = hour2.split(':');
    const totalHours = parseFloat(hours1) + parseFloat(hours2);
    const totalMinutes = parseFloat(minutes1) + parseFloat(minutes2);
    if (totalMinutes >= 60) {
        return `${(totalHours + 1).toString().padStart(2, '0')}:${(totalMinutes - 60).toString().padStart(2, '0')}`;
    } else {
        return `${totalHours.toString().padStart(2, '0')}:${totalMinutes.toString().padStart(2, '0')}`;
    }
}

const removeHourToHour = async (hour1: string, hour2: string) : Promise<string> => { //remove hour2 to hour1
    const [hours1, minutes1] = hour1.split(':');
    const [hours2, minutes2] = hour2.split(':');
    const totalHours = parseFloat(hours1) - parseFloat(hours2);
    const totalMinutes = parseFloat(minutes1) - parseFloat(minutes2);
    if (totalMinutes < 0) {
        return `${(totalHours - 1).toString().padStart(2, '0')}:${(totalMinutes + 60).toString().padStart(2, '0')}`;
    } else {
        return `${totalHours.toString().padStart(2, '0')}:${totalMinutes.toString().padStart(2, '0')}`;
    }
}

const calculateLengthBetweenHours = async (hour1: string, hour2: string) : Promise<string> => {
    const [hours1, minutes1] = hour1.split(':');
    const [hours2, minutes2] = hour2.split(':');
    const totalHours = parseFloat(hours2) - parseFloat(hours1);
    const totalMinutes = parseFloat(minutes2) - parseFloat(minutes1);
    if (totalMinutes < 0) {
        return `${(totalHours - 1).toString().padStart(2, '0')}:${(totalMinutes + 60).toString().padStart(2, '0')}`;
    }
    return `${totalHours.toString().padStart(2, '0')}:${totalMinutes.toString().padStart(2, '0')}`;
}

const formatDateToFrench = (dateString: string): string => {
    // Vérifier si dateString existe et n'est pas vide
    if (!dateString || typeof dateString !== 'string') {
        return '';
    }
    
    // Vérifier si la date est au format français (DD/MM/YYYY)
    if (dateString.includes('/')) {
        const [day, month, year] = dateString.split('/');
        const date = new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
        
        // Tableaux pour les jours et mois en français
        const jours = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
        const mois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
        
        const jour = jours[date.getDay()];
        const jourNumero = date.getDate();
        const moisNom = mois[date.getMonth()];
        const annee = date.getFullYear();
        
        return `${jour} ${jourNumero} ${moisNom} ${annee}`;
    } else {
        // Format ISO ou autre format standard
        const date = new Date(dateString);
        
        // Tableaux pour les jours et mois en français
        const jours = ['dimanche', 'lundi', 'mardi', 'mercredi', 'jeudi', 'vendredi', 'samedi'];
        const mois = ['janvier', 'février', 'mars', 'avril', 'mai', 'juin', 'juillet', 'août', 'septembre', 'octobre', 'novembre', 'décembre'];
        
        const jour = jours[date.getDay()];
        const jourNumero = date.getDate();
        const moisNom = mois[date.getMonth()];
        const annee = date.getFullYear();
        
        return `${jour} ${jourNumero} ${moisNom} ${annee}`;
    }
}

// Fonction pour parser le format de date français "DD/MM/YYYY HH:mm:ss"
const parseFrenchDate = (dateString: string): Date | null => {
    if (!dateString) return null;
    
    // Format attendu: "DD/MM/YYYY HH:mm:ss" ou "DD/MM/YYYY"
    const parts = dateString.split(' ');
    const datePart = parts[0]; // "DD/MM/YYYY"
    const timePart = parts[1] || "00:00:00"; // "HH:mm:ss" ou "00:00:00" par défaut
    
    const [day, month, year] = datePart.split('/').map(Number);
    const [hours, minutes, seconds] = timePart.split(':').map(Number);
    
    if (isNaN(day) || isNaN(month) || isNaN(year)) return null;
    
    // Créer une date en format ISO (YYYY-MM-DDTHH:mm:ss)
    return new Date(year, month - 1, day, hours || 0, minutes || 0, seconds || 0);
  };
  

export { calculateDecimalFromDelta, convertHourToDecimal, convertDecimalToHour, addHourToHour, removeHourToHour, calculateLengthBetweenHours, formatDateToFrench, parseFrenchDate };